export const CONFIG = typeof window !== `undefined` ? window.config : null
